import { render, staticRenderFns } from "./JournalIcon.vue?vue&type=template&id=393b1700&scoped=true&"
import script from "./JournalIcon.vue?vue&type=script&lang=js&"
export * from "./JournalIcon.vue?vue&type=script&lang=js&"
import style0 from "./JournalIcon.vue?vue&type=style&index=0&id=393b1700&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393b1700",
  null
  
)

export default component.exports